'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardAccountResponse(credentialsByKind, activeUsers, registeredUsers, scope, accounts) {
  this.xt = null;
  this.E7 = 0;
  this.E8 = null;
  this.E9 = null;
  this.E6 = null;
  this.xt = credentialsByKind;
  this.E7 = activeUsers;
  this.E8 = registeredUsers;
  this.E9 = scope;
  this.E6 = accounts;
}
export { $c_Lpresto_types$DashboardAccountResponse as $c_Lpresto_types$DashboardAccountResponse };
$p = $c_Lpresto_types$DashboardAccountResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardAccountResponse;
/** @constructor */
function $h_Lpresto_types$DashboardAccountResponse() {
}
export { $h_Lpresto_types$DashboardAccountResponse as $h_Lpresto_types$DashboardAccountResponse };
$h_Lpresto_types$DashboardAccountResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardAccountResponse"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xt));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.E7);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.E8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.E9));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.E6));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 5);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardAccountResponse)) {
    if ((this.E7 === x$0.E7)) {
      var x = this.xt;
      var x$2 = x$0.xt;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.E8;
      var x$4 = x$0.E8;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.E9;
      var x$6 = x$0.E9;
      var $x_1 = (x$5 === x$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.E6;
      var x$8 = x$0.E6;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "DashboardAccountResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xt;
      break;
    }
    case 1: {
      return this.E7;
      break;
    }
    case 2: {
      return this.E8;
      break;
    }
    case 3: {
      return this.E9;
      break;
    }
    case 4: {
      return this.E6;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardAccountResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jG)));
}
export { $isArrayOf_Lpresto_types$DashboardAccountResponse as $isArrayOf_Lpresto_types$DashboardAccountResponse };
var $d_Lpresto_types$DashboardAccountResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardAccountResponse, "presto.types$DashboardAccountResponse", ({
  jG: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardAccountResponse as $d_Lpresto_types$DashboardAccountResponse };
//# sourceMappingURL=presto.types$-Dashboard-Account-Response.js.map
